import { useMemo } from 'react';
import { CircularLoader, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { QueryKeys } from "../../hooks/reactQuery/queryKeys";
import { useQueryState } from "../../hooks/reactQuery/useQueryState";
import { RichTextViewer } from "../../RichTextViewer";
import styles from "./RichTextViewerWithFetch.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const RichTextViewerWithFetchTestIds = getTestIds('RichTextViewerWithFetchTestIds');
export function getDefaultText(text) {
  if (!text) {
    return [];
  }
  return typeof text === 'string' ? [{
    typ: 'p',
    children: [{
      text
    }]
  }] : text;
}
export function RichTextViewerWithFetch(_ref) {
  let {
    text,
    fetchText,
    queryKey
  } = _ref;
  const {
    data: richText,
    isLoading
  } = useQueryState({
    queryKey: [QueryKeys.RichText, queryKey],
    queryFn: () => fetchText === null || fetchText === void 0 ? void 0 : fetchText(),
    enabled: !!fetchText
  });
  const loader = useMemo(() => /*#__PURE__*/_jsx("div", {
    "data-testid": RichTextViewerWithFetchTestIds.Loader(),
    style: {
      position: 'absolute',
      top: 'calc(50% - 16px)',
      left: 'calc(50% - 16px)'
    },
    children: /*#__PURE__*/_jsx(CircularLoader, {
      size: 32
    })
  }), []);
  if (isLoading) {
    return loader;
  }
  return /*#__PURE__*/_jsx("div", {
    className: styles.container,
    "data-testid": RichTextViewerWithFetchTestIds.Container(),
    children: /*#__PURE__*/_jsx(Typography, {
      children: /*#__PURE__*/_jsx(RichTextViewer, {
        value: getDefaultText(richText !== null && richText !== void 0 ? richText : text)
      })
    })
  });
}